import { render, staticRenderFns } from "./RegulatoryChanges.vue?vue&type=template&id=44be40bd&"
import script from "./RegulatoryChanges.vue?vue&type=script&lang=js&"
export * from "./RegulatoryChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports